import { createSlice } from "@reduxjs/toolkit";

const aepsSlice = createSlice({
  name: "aeps",
  initialState: {
    pipe: "",
    banks: {},
  },
  reducers: {
    setAepsPipe: (state, action) => {
      state.pipe = action.payload;
    },
    setAepsBanks: (state, action) => {
      state.banks = action.payload;
    },
  },
});

export const { setAepsPipe, setAepsBanks } = aepsSlice.actions;
export default aepsSlice.reducer;
